var _path, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,15.2c0,0,0-0.7,0-2.2c0-0.5-0.3-0.9-0.7-1.1c-0.6-0.3-1.2-0.5-1.5-0.6l-0.7-3.4h0.5l-0.1-0.4 C20.2,7.2,20,7,19.7,7h-0.1h-3.9H1.2C1.1,7,1,7.1,1,7.2v8.1c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0,0c0.6,0,2,0,2.8,0c1.2,0,2.6,0,4,0 c2.7,0,5.6,0,8.2,0c1.5,0,2.9,0,4,0c1.5,0,2.5,0,2.6,0l0,0l0,0c0,0,0.1,0,0.1-0.1C22.8,15.3,22.8,15.3,22.8,15.2z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#000"
    },
    points: "16.4,8.2 19.1,8.2 19.7,11.1 16.4,11.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.8,
    y: 8.2,
    style: {
      fill: "#000"
    },
    width: 3,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.2,
    y: 8.2,
    style: {
      fill: "#000"
    },
    width: 3,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.6,
    y: 8.2,
    style: {
      fill: "#000"
    },
    width: 3,
    height: 2.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.9,
    y: 8.2,
    style: {
      fill: "#000"
    },
    width: 3,
    height: 2.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "M20.8,14.2H23l0,0c0,0.8-0.7,1.5-1.5,1.5h-0.8V14.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.1,
    cy: 15.4,
    r: 1.6
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1,
    cy: 15.4,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 18.1,
    cy: 15.4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.9,
    cy: 15.4,
    r: 1.6
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.9,
    cy: 15.4,
    r: 1
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000"
    },
    cx: 5.9,
    cy: 15.4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 11.5,
    style: {
      fill: "#000"
    },
    width: 19.3,
    height: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 13,
    style: {
      fill: "#000"
    },
    width: 19.3,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6,
    y: 14.1,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.3,
    y: 14.1,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.7,
    y: 14.1,
    style: {
      fill: "#000"
    },
    width: 0.7,
    height: 0.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.7e1b0dfc5b138a15494de593ad133254.svg";
export { ForwardRef as ReactComponent };